import * as Scrivito from "scrivito";
import blogObjIcon from "assets/images/blog_obj.svg";
import SectionWidget from "widgets/SectionWidget/SectionWidgetClass";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("ProductList", {
  title: "Product List",
  thumbnail: blogObjIcon,
  attributes: {
    defaultProductImage: {
      title: "Default Image for Products",
      description:
        "This image is displayed as Product-Image, if the Image is not available.",
    },
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
  },
  properties: [
    "productsNavigationTitle",
    "defaultProductImage",
    ...defaultPageProperties,
  ],
  propertiesGroups: [
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    title: "Product List",
    productsNavigationTitle: "Products",
    showConfiguratorNav: true,
    body: [new SectionWidget({})],
  },
  validations: [
    ...metadataValidations,
    ...metadataValidations,
    [
      "defaultProductImage",
      (defaultProductImage) => {
        if (defaultProductImage === null) {
          return {
            message: "The Default Image should be set.",
            severity: "error",
          };
        }
      },
    ],
  ],
});
